import React, { useEffect, useRef, useState } from "react";
import classes from "./VideoProgressBar.module.scss";
import {
  BiVideo,
  BiMinus,
  BiAddToQueue,
  BiInfoCircle,
  BiRefresh,
} from "react-icons/bi";
import { FcCancel } from "react-icons/fc";
import { MdCancel } from "react-icons/md";
import Tooltip from "../ToolTip/Tooltip";
import Portal from "../Modal/Portal";
import { videoUploadStatus } from "../../../utils/videoUploadStatus";
import { useSelector } from "react-redux";
import {
  setShowVideoUploadListPanelAction,
  setUpdateVideoListAction,
} from "../../../store/actions/actionCreators/manageActionCreator";
import { useDispatch } from "react-redux";
import Input from "../Input/Input";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import {
  setMetaDataForVideoActionHandler,
  uploadVideoChunkActionHandler,
  userCancelledVideoUploadActionHandler,
} from "../../../store/actions/actionHandlers/manageActionHandler";
import { FormProvider, useForm } from "react-hook-form";

const VideoProgressBar = () => {
  const dispatch = useDispatch();
  const reUploadVideoRef = useRef();

  const manageState = useSelector((state) => state.manageReducer);
  const { videoUploadList, showVideoUploadListPanel } = manageState;

  const methods = useForm({
    defaultValues: { reUploadVideo: null },
  });

  const [isVisible, setIsVisible] = useState(false);
  const [allCompleted, setAllCompleted] = useState(false);

  useEffect(() => {
    if (videoUploadList?.length > 0) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
    let count = 0;
    videoUploadList.forEach((video) => {
      if (video?.currentStatus === videoUploadStatus.COMPLETED) {
        count++;
      }
    });
    if (count === videoUploadList?.length) {
      setAllCompleted(true);
    } else {
      setAllCompleted(false);
    }
  }, [videoUploadList]);

  const removeVideoItem = (id) => {
    const updatedVideoList = videoUploadList?.filter(
      (video) => video?.id !== id
    );
    dispatch(setUpdateVideoListAction(updatedVideoList));
  };

  const removeAllVideoItems = () => {
    dispatch(setUpdateVideoListAction([]));
    setIsVisible(false);
  };

  const handleCancelVideoItem = (id) => {
    const updatedVideoList = videoUploadList?.map((video) => {
      if (video?.id === id) {
        return {
          ...video,
          currentStatus: videoUploadStatus.CANCELLED,
        };
      }
      return video;
    });
    dispatch(setUpdateVideoListAction(updatedVideoList));
    dispatch(userCancelledVideoUploadActionHandler(id)).then((data) => {
      if (data) {
      }
    });
  };

  const handleReUploadVideo = (e, id) => {
    const file = e?.target?.files[0];
    const fileName = file?.name;
    const lastIndexVal = (fileName.lastIndexOf(".") - 1) >>> 0;
    const fileExtension = fileName.slice(lastIndexVal + 2);
    const fileSize = file?.size;
    const blockLength = 1048576;
    const blockCount = Math.ceil(fileSize / blockLength);
    const acceptedTypes = ["avi", "mp4", "mpg", "wmv", "mov", "mp3", "m4a"];
    if (acceptedTypes.includes(fileExtension)) {
      const videoItem = videoUploadList?.find((video) => video?.id === id);
      dispatch(
        setMetaDataForVideoActionHandler(
          blockCount,
          fileName,
          fileSize,
          videoItem?.className
        )
      )
        .then((data) => {
          let uploadChunkObject = {
            videoGuid: data?.VideoGuid,
            // classId: classId,
            classId: videoItem?.chunkObject?.classId,
            isVariant: false,
            status: videoItem?.chunkObject?.status,
            fileName: fileName,
            url: "uploading",
            fileSize: fileSize,
            blockLength: blockLength,
            blockCount: blockCount,
            uploadStatusMessage: "xsadsd",
            isUploadCompleted: false,
            isShotClassSourcingFromLearner: false,
            file: file,
          };
          const updatedVideoItem = {
            id: videoItem?.id,
            name: fileName,
            totalChunk: blockCount,
            completedChunk: 0,
            className: videoItem?.className,
            currentStatus: videoUploadStatus.PENDING,
            chunkObject: uploadChunkObject,
          };
          const updatedVideoList = videoUploadList?.map((video) => {
            if (video?.id === id) {
              return updatedVideoItem;
            }
            return video;
          });
          dispatch(setUpdateVideoListAction(updatedVideoList));
          dispatch(
            uploadVideoChunkActionHandler(uploadChunkObject, videoItem?.id)
          );
          return true;
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      dispatch(
        setErrorHandler(errorTypes.WARN, "Please select a valid format")
      );
    }
  };

  return (
    isVisible && (
      <Portal id="videoBar">
        <FormProvider {...methods}>
          <div className={classes.videoProgressBar}>
            <div className={classes.videoProgressBar__header}>
              <div className={classes.videoProgressBar__header__left}>
                <div className={classes.videoProgressBar__icon}>
                  <BiVideo />
                </div>
                <div>Video Upload Progress</div>
              </div>
              <div className={classes.videoProgressBar__header__right}>
                <div
                  className={classes.videoProgressBar__icon}
                  onClick={() =>
                    dispatch(
                      setShowVideoUploadListPanelAction(
                        !showVideoUploadListPanel
                      )
                    )
                  }
                >
                  {showVideoUploadListPanel ? <BiMinus /> : <BiAddToQueue />}
                </div>
                {allCompleted && (
                  <div
                    className={classes.videoProgressBar__icon}
                    onClick={() => removeAllVideoItems()}
                  >
                    <MdCancel />
                  </div>
                )}
              </div>
            </div>
            {showVideoUploadListPanel && (
              <div className={classes.videoProgressBar__videoList}>
                {videoUploadList?.map((video) => {
                  const width = Math.floor(
                    (video?.completedChunk * 100) / video?.totalChunk
                  );
                  return (
                    <div
                      className={classes.videoProgressBar__videoList__videoItem}
                      key={video?.id}
                    >
                      <div
                        className={
                          classes.videoProgressBar__videoList__videoItem__header
                        }
                      >
                        <div
                          className={
                            classes.videoProgressBar__videoList__videoItem__header__left
                          }
                        >
                          <Tooltip content={video?.name} direction="left">
                            <div
                              className={
                                classes.videoProgressBar__videoList__videoItem__header__left__text
                              }
                            >
                              {video?.name}
                            </div>
                          </Tooltip>
                        </div>
                        <div
                          className={
                            classes.videoProgressBar__videoList__videoItem__header__right
                          }
                        >
                          <div className={classes.videoProgressBar__icon}>
                            <Tooltip content={video.className} direction="left">
                              <BiInfoCircle />
                            </Tooltip>
                          </div>
                          {video?.currentStatus ===
                            videoUploadStatus.NOT_STARTED ||
                          video?.currentStatus === videoUploadStatus.PENDING ? (
                            <div
                              className={classes.videoProgressBar__icon}
                              onClick={() => handleCancelVideoItem(video?.id)}
                            >
                              <FcCancel />
                            </div>
                          ) : video?.currentStatus ===
                            videoUploadStatus.CANCELLED ? (
                            <div
                              className={classes.videoProgressBar__icon}
                              onClick={() => reUploadVideoRef.current.click()}
                            >
                              <BiRefresh />
                              <Input
                                type="file"
                                name="reUploadVideo"
                                hidden={true}
                                reference={reUploadVideoRef}
                                accept=".avi, .mp4, .mpg, .wmv, .mov, .mp3, .m4a"
                                fileInputButton={false}
                                fileInputName="false"
                                width="0"
                                onChange={(e) =>
                                  handleReUploadVideo(e, video?.id)
                                }
                              />
                            </div>
                          ) : video?.currentStatus ===
                            videoUploadStatus.COMPLETED ? (
                            <div
                              className={classes.videoProgressBar__icon}
                              onClick={() => removeVideoItem(video?.id)}
                            >
                              <MdCancel />
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <div
                        className={
                          classes.videoProgressBar__videoList__videoItem__widthContainer
                        }
                      >
                        <div
                          style={{ width: width + "%" }}
                          className={
                            classes.videoProgressBar__videoList__videoItem__widthContainer__width
                          }
                        >
                          {width > 0 && (
                            <div
                              className={
                                classes.videoProgressBar__videoList__videoItem__widthContainer__width__text
                              }
                            >
                              {width + "%"}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </FormProvider>
      </Portal>
    )
  );
};

export default VideoProgressBar;
